import * as React from "react"
import { Bar } from "react-chartjs-2"
import { injectIntl, InjectedIntlProps, FormattedNumber } from "react-intl"
import * as CounterDomain from "../../domain/sfp/counter-domain"
import { ColorsHelper } from "../../util/colors"

class CounterChart extends React.Component<injectProps> {
	render() {
		return <div style={{ height: 200, position: "relative" }}>
		<Bar data={this.data} options={this.options} />
	</div>
	}

	private get data(): Chart.ChartData {
		const backgroundColor = [
			ColorsHelper.getPastelColor(1), // Couleur pour referentiel
			ColorsHelper.getPastelColor(35), // Couleur pour les dépenses
			ColorsHelper.getPastelColor(200), // Couleur pour le budget annuel
			ColorsHelper.getPastelColor(122) // Couleur pour budget disponible
		]
		const borderColor = ColorsHelper.getPastelColor(201)

		return {
			labels: [
				"Total dépenses",
				"Référentiel",
				"Budget annuel",
				"Budget disponible"
			],
			datasets: [{
				backgroundColor,
				borderColor,
				data: [
					this.props.budgetEvolution.totalExpense,
					this.props.budgetEvolution.repository,
					this.props.budgetEvolution.annualBudget,
					this.props.budgetEvolution.availableBudget
				]
			}]
		}
	}

	private get options(): Chart.ChartOptions {
		const currencyOptions: FormattedNumber.PropsBase = {
			currency: "EUR",
			style: "currency"
		}

		return {
			legend: { display: false },
			maintainAspectRatio: false,
			responsive: true,
			scales: {
				xAxes: [{ offset: true }],
				yAxes: [{
					ticks: {
						beginAtZero: true,
						callback: (value, index, values) => (
							this.props.intl.formatNumber(value, currencyOptions)
						)
					}
				}]
			},
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex = tooltip.datasetIndex
					const dataIndex = tooltip.index
					const value = data.datasets[datasetIndex].data[dataIndex] as number
					const formattedValue = this.props.intl.formatNumber(value, currencyOptions)
					return `${formattedValue}`
				}
			}}
		}
	}
}

export default injectIntl(CounterChart)

interface Props {
	budgetEvolution: CounterDomain.BaseBudgetEvolution;
}

type injectProps = Props & InjectedIntlProps



// WEBPACK FOOTER //
// ./src/component/counter/counter-chart.tsx